import { render } from "./staff_notification.vue?vue&type=template&id=1110c2ee&scoped=true"
import script from "./staff_notification.vue?vue&type=script&lang=js"
export * from "./staff_notification.vue?vue&type=script&lang=js"

import "./staff_notification.vue?vue&type=style&index=0&id=1110c2ee&scoped=true&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1110c2ee"]])

export default __exports__